<template>
<div class="login">
  <PrivateHeader></PrivateHeader>
  <div class="header1">
    <img src="~pic/login-logo.png" />
  </div>
  <div class="content">
    <Form ref="login_form" :model="form_params" :rules="rule_list">
      <FormItem prop="mobile">
        <Input v-model="form_params.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
      </FormItem>
      <FormItem prop="picture">
        <Input v-model="form_params.picture" placeholder="图片验证码" autocomplete="off"></Input>
        <img :src="picture" class="pic-code" @click="changePicCode">
      </FormItem>
      <FormItem prop="code">
        <Input v-model="form_params.code" placeholder="请输入验证码" autocomplete="off"></Input>
        <span class="code_btn" @click="handleCode()" v-if="userWait == 60">获取验证码</span>
        <span class="code_btn disabled_btn" v-else="userWait != 60">已发送 ({{userWait}}s)</span>
      </FormItem>
    </Form>
  </div>
  <div class="footer">
    <Button long @click="handleLogin">登录</Button>
  </div>
</div>
</template>

<script>
import {
  login,
  getMobileCode
} from '../../service'
import moment from 'moment'
import PrivateHeader from '../../components/Headers/header2'
export default {
  components: {
    PrivateHeader
  },
  name: 'Login',
  data() {
    return {
      login_index: false,
      form_params: {
        mobile: '',
        picture: '',
        code: ''
      },
      rule_list: {
        'mobile': [{
            required: true,
            message: '请输入您的联系电话',
            trigger: 'blur'
          },
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            }
          }
        ],
        'code': [{
          required: true,
          message: '请填写正确的验证码',
          trigger: 'blur'
        }],
        'picture': [{
          required: true,
          message: '请填写正确的图片验证码',
          trigger: 'blur'
        }]
      },
      userWait: 60,
      picture: ''
    }
  },
  methods: {
    cancelLogin() {
      this.userWait = 60
      clearTimeout(this.codeTimeout)
      this.$refs['login_form'].resetFields()
    },
    async handleCode() {
      this.$refs['login_form'].validateField('mobile', async (valid) => {
        this.$refs['login_form'].validateField('picture', async (valid2) => {
          if (!valid && !valid2) {
            let res = await getMobileCode({
              mobile: this.form_params.mobile
            }, (error) => {
              this.$Message.error('请求失败！')
            })
            this.userCodeClk()
          }
        })
      })
    },
    userCodeClk() {
      if (this.userWait == 0) {
        this.userWait = 60;
      } else {
        this.userWait--;
        this.codeTimeout = setTimeout(() => {
          this.userCodeClk()
        }, 1000)
      }
    },
    changePicCode(t) {
      this.picture = this.$store.state.req_url + '/getImgCode?' + Math.random()
    },
    handleLogin() {
      this.$refs['login_form'].validate(async (valid) => {
        if (valid) {
          let res = await login(this.form_params, (error) => {
            this.$Message.error('请求失败！')
          })
          if (res.status == 'success') {
            localStorage.user_key = res.user_key
            localStorage.user_mobile = res.mobile
            localStorage.user = res.xuser ? JSON.stringify(res.xuser): JSON.stringify({})
            localStorage.timestamp_left = moment().unix()
            localStorage.timestamp_right = moment().unix()
            this.$store.commit('updateUserKey', res.user_key)
            this.$store.commit('updateUser', res.xuser ? res.xuser : {})
            this.$store.commit('updateUserMobile', res.mobile)
            if(!res.xuser) {
              this.$router.push({name: 'SetUserInfo'})
            }else{
              this.$router.go(-1)
            }
          } else {
            this.$Message.error(res.message);
          }
        }
      })
    },
  },
  created() {
    this.picture =  this.$store.state.req_url + '/getImgCode?' + Math.random()
  }
}
</script>

<style lang="stylus">
.login
  padding-top: .88rem
  .header1
    padding-top: 1.64rem
    text-align: center
    img
      width: 5.6rem
  .content
    > p
      font-size: 16px
      font-weight: bold
      color: rgba(51,51,51,1)
      line-height: 1
    .ivu-form
      margin-top: .4rem
      padding: 0 .8rem
      .ivu-form-item
        margin-bottom: .2rem
        .ivu-form-item-content
          .ivu-input
            border: 0
            border-bottom: 1px solid #DDDDDD
            border-radius: 0
            color: #333
            height: .8rem
            font-size: .3rem
            padding: .2rem 0
            &::-webkit-input-placeholder
              color: #CCCCCC
            &:focus
              box-shadow: none
          .code_btn
            position: absolute
            cursor: pointer
            line-height: 1
            color: #E12222
            top: .28rem
            right: .2rem
            &.disabled_btn
              color: #999999
          .pic-code
            position: absolute
            width: 1.56rem
            height: .6rem
            right: 0
            top: .12rem
            border-radius: 0
        &:last-of-type
            margin-bottom: 0
        .ivu-form-item-error-tip
          position: inherit
          color: #E12222
          padding-left: 0
        &.ivu-form-item-error
          .ivu-input
            border-color: #E12222
  .footer
    padding: 1.2rem .8rem
    border: 0
    .ivu-btn
      height: 40px
      background: #e12222
      border-radius: 4px
      border: 0
      span
        font-size: 14px
        font-weight: bold
        color: rgba(255,255,255,1)
      &:focus
        box-shadow: none
</style>
